<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>افزودن اشخاص/موسسات</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">
                    <div class="input-style input-style-2 has-icon input-required">
                        <div class="d-flex">
                            <div class="w-100">
                                <i class="input-icon fa fa-hashtag color-magenta2-light"></i>
                                <span class="color-highlight" :class="{'input-style-1-active' : personModel.code!==null}">کد</span>
                                <input class="form-control ltr d-inline-block" type="text" readonly v-model="personModel.code" @input="v$.personModel.code.$touch()" :class="{invalid:v$.personModel.code.$error}">
                            </div>
                            <button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="getPersonNo"><i class="fa fa-redo"></i></button>
                        </div>
                        <p class="text-danger" v-if="v$.personModel.code.required.$invalid && v$.personModel.code.$dirty">:کد وارد نشده است</p>
                    </div>
                    <div class="mb-3">
                        <persongroup-select v-model="personModel.personGroupIds"></persongroup-select>
                        <p class="text-danger" v-if="v$.personModel.personGroupIds.required.$invalid && v$.personModel.personGroupIds.$dirty">لطفا دسته بندی را انتخاب کنید.</p>

                    </div>
                    <div class="mb-3">
                        <v-select :class="{invalid:v$.personModel.ownerShipTypeId.$error}" dir="rtl" label="title" placeholder="نوع مالکیت" :searchable="false" :options="ownerShipTypeList" :reduce="p => p.ownerShipTypeId" v-model="personModel.ownerShipTypeId">
                            <template slot="option"  >
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.personModel.ownerShipTypeId.required.$invalid && v$.personModel.ownerShipTypeId.$dirty">لطفا نوع مالکیت را انتخاب کنید.</p>
                    </div>

                    <div class="mb-3" v-if="personModel.ownerShipTypeId==2">
                        <v-select :class="{invalid:v$.personModel.legalTypeId.$error}" dir="rtl" label="title" placeholder="نوع مالکیت" :searchable="false" :options="legalTypeList" :reduce="p => p.legalTypeId" v-model="personModel.legalTypeId">
                            <template slot="option"  >
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.personModel.legalTypeId.required.$invalid && v$.personModel.legalTypeId.$dirty">لطفا نوع مالکیت را انتخاب کنید.</p>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required" v-show="personModel.ownerShipTypeId==1">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : personModel.firstName!==null}">نام</span>
                        <input class="form-control" type="text" v-model="personModel.firstName" @input="v$.personModel.firstName.$touch()" :class="{invalid:v$.personModel.firstName.$error}" @blur="onNameChange">
                        <p class="text-danger" v-if="v$.personModel.firstName.required.$invalid && v$.personModel.firstName.$dirty">لطفا نام را وارد کنید.</p>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required" v-show="personModel.ownerShipTypeId==1">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : personModel.lastName!==null}">نام خانوادگی</span>
                        <input class="form-control" type="text" v-model="personModel.lastName" @input="v$.personModel.lastName.$touch()" :class="{invalid:v$.personModel.lastName.$error}" @blur="onNameChange">
                        <p class="text-danger" v-if="v$.personModel.lastName.required.$invalid && v$.personModel.lastName.$dirty">لطفا نام خانوادگی را وارد کنید.</p>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required" v-show="personModel.ownerShipTypeId!=1">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : personModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="personModel.title" @input="v$.personModel.title.$touch()" :class="{invalid:v$.personModel.title.$error}">
                        <p class="text-danger" v-if="v$.personModel.title.required.$invalid && v$.personModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="mb-3">
                        <v-select dir="rtl" label="title" placeholder="روش ارتباط" :searchable="false" :options="communicationTypeList" :reduce="p => p.communicationTypeId" v-model="personModel.communicationTypeId">
                            <template slot="option"  >
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-hashtag color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : personModel.reference!==null}">شناسه</span>
                        <input class="form-control" type="text" v-model="personModel.reference" @input="v$.personModel.reference.$touch()" :class="{invalid:v$.personModel.reference.$error}">
                        <p class="text-danger" v-if="v$.personModel.reference.maxLength.$invalid && v$.personModel.reference.$dirty">شناسه نباید بیشتر از ۲۰۰ کاراکتر باشد.</p>
                    </div>


                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-pen color-magenta2-light"></i>
                        <span class="color-highlight">توضیحات</span>
                        <textarea v-model="personModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px"></textarea>
                    </div>
                    <div class="border rounded-s px-3 pt-2 mb-3">
                        <label>نشانی:</label>
                        <div class="mb-3">
                            <state-select :class="{invalid:v$.personDetailsModel.stateId.$error}" v-model="personDetailsModel.stateId"></state-select>
                            <p class="text-danger" v-if="v$.personDetailsModel.stateId.requiredIfState.$invalid">لطفاشهر/شهرستان را انتخاب کنید.</p>

                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.title!==null}">عنوان</span>
                            <input class="form-control" type="text" v-model="personDetailsModel.title" @input="v$.personDetailsModel.title.$touch()" :class="{invalid:v$.personDetailsModel.title.$error}">
                            <p class="text-danger" v-if="v$.personDetailsModel.title.requiredIfTitle.$invalid && v$.personDetailsModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                        </div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-phone color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.phoneNumber!==null}">شماره تلفن</span>
                            <input class="form-control" type="tel" v-model="personDetailsModel.phoneNumber">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-mobile color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.mobileNumber!==null}">شماره موبایل</span>
                            <input class="form-control" type="tel" v-model="personDetailsModel.mobileNumber">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-fax color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.faxNumber!==null}">شماره دورنگار</span>
                            <input class="form-control" type="tel" v-model="personDetailsModel.faxNumber">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-envelope color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.emailAddress!==null}">آدرس ایمیل</span>
                            <input class="form-control" type="email" v-model="personDetailsModel.emailAddress"  @input="v$.personDetailsModel.emailAddress.$touch()" :class="{invalid:v$.personDetailsModel.emailAddress.$error}">
                            <p class="text-danger" v-if="v$.personDetailsModel.emailAddress.email.$invalid && v$.personDetailsModel.emailAddress.$dirty">آدرس ایمیل معتبر نمی باشد..</p>

                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-globe color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.webSiteAddress!==null}" >آدرس سایت</span>
                            <input class="form-control" type="text" v-model="personDetailsModel.webSiteAddress" @input="v$.personDetailsModel.webSiteAddress.$touch()" :class="{invalid:v$.personDetailsModel.webSiteAddress.$error}">
                            <p class="text-danger" v-if="v$.personDetailsModel.webSiteAddress.url.$invalid && v$.personDetailsModel.webSiteAddress.$dirty">آدرس سایت معتبر نمی باشد..</p>

                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-mail-bulk color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.postCode!==null}">کد پستی</span>
                            <input class="form-control" type="tel" v-model="personDetailsModel.postCode">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required mb-3">
                            <i class="input-icon fa fa-map-marker-alt color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personDetailsModel.address!==null}">آدرس</span>
                            <textarea v-model="personDetailsModel.address" class="form-control line-height-m text-justify" rows="3" style="height:200px"></textarea>
                        </div>
                    </div>


                    <div class="border rounded-s px-3 pt-2">
                        <label>اشخاص مرتبط و صاحبان امضاء:</label>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personRelativeModel.fullName!==null}">عنوان</span>
                            <input class="form-control" type="text" v-model="personRelativeModel.fullName" @input="v$.personRelativeModel.fullName.$touch()" :class="{invalid:v$.personRelativeModel.fullName.$error}">
                            <p class="text-danger" v-if="v$.personRelativeModel.fullName.required.$invalid && v$.personRelativeModel.fullName.$dirty">لطفا عنوان را وارد کنید.</p>
                        </div>

                        <div class="mb-3">
                            <v-select dir="rtl" label="title" placeholder="جنسیت" :searchable="false" :options="genderList" :reduce="p => p.value" v-model="personRelativeModel.gender">
                                <template slot="option"  >
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personRelativeModel.postTitle!==null}">عنوان شغلی</span>
                            <input class="form-control" type="text" v-model="personRelativeModel.postTitle">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-phone color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personRelativeModel.phoneNumber!==null}">شماره تلفن</span>
                            <input class="form-control" type="tel" v-model="personRelativeModel.phoneNumber" pattern="\d*">
                        </div>

                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-mobile color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personRelativeModel.mobileNumber!==null}">شماره موبایل</span>
                            <input class="form-control" type="tel" v-model="personRelativeModel.mobileNumber" pattern="\d*">
                        </div>


                        <div class="input-style input-style-2 has-icon input-required mb-3">
                            <i class="input-icon fa fa-envelope color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : personRelativeModel.emailAddress!==null}">آدرس ایمیل</span>
                            <input class="form-control" type="email" v-model="personRelativeModel.emailAddress"  @input="v$.personRelativeModel.emailAddress.$touch()" :class="{invalid:v$.personRelativeModel.emailAddress.$error}">
                            <p class="text-danger" v-if="v$.personRelativeModel.emailAddress.email.$invalid && v$.personRelativeModel.emailAddress.$dirty">آدرس ایمیل معتبر نمی باشد..</p>

                        </div>
                </div>
                    <button :disabled="Loading" class="btn btn-xxs mt-3 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreatePerson">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required, requiredIf, maxLength, email,url
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
  import { maska } from 'maska'
    import PersonGroupSelect from '../Components/PersonGroupSelect.vue';
    import StateSelect from '../Components/StateSelect.vue';
   // import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
        components: {
            //   DatePicker,
            "persongroup-select": PersonGroupSelect,
            "state-select": StateSelect
           
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                ownerShipTypeList: [{ title: "حقیقی", ownerShipTypeId: 1 }, { title: "حقوقی", ownerShipTypeId: 2 }],
                genderList: [{ title: "مرد", value: "1" }, { title: "زن", value: "0" }],
                personModel: {
                    code: null,
                    title: null,
                    ownerShipTypeId: null,
                    legalTypeId: null,
                    firstName:  "",
                    lastName: "",
                    communicationTypeId: null,
                    reference: null,
                    description: null,
                    personGroupIds:[],
                    personGroupIdsStr: null,
                    personDetailViewModel: [],
                    personRelativeViewModel:[]
                },
                personDetailsModel: {
                    title: null,
                    stateId: null,
                    phoneNumber: null,
                    mobileNumber: null,
                    faxNumber: null,
                    emailAddress: null,
                    webSiteAddress: null,
                    address: null,
                    plateNo: null,
                    unitNo: null,
                    postCode:null
                },
                personRelativeModel: {
                    fullName: null,
                    gender: null,
                    mobileNumber: null,
                    phoneNumber: null,
                    postTitle: null,
                    emailAddress:null
                }

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            
            legalTypeList() {
                return this.$store.getters.GetLegalTypeList;
            },
            communicationTypeList() {
                return this.$store.getters.GetCommunicationTypeList;
            },
            isNullDetails() {
                var isNullish = Object.values(this.personDetailsModel).every(value => {
                    if (value !== null && value!=="" && value!=0) {
                        return false;
                    }

                    return true;
                });
                return isNullish;
            },
            isNullRelative() {
                var isNullish = Object.values(this.personRelativeModel).every(value => {
                    if (value !== null && value !== "") {
                        return false;
                    }

                    return true;
                });
                return isNullish;
            },
        },
        created() {
            this.$store.dispatch("GetLegalTypeListFromServer");
            this.$store.dispatch("GetCommunicationTypeListFromServer");
            this.getPersonNo();
        },
       
       
        methods: {
            CreatePerson() {
                this.replacePersianNumbers();
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) {
                    if (this.isNullDetails == false) {
                        this.personModel.personDetailViewModel = [];
                        this.personModel.personDetailViewModel.push(this.personDetailsModel);
                    }
                    if (this.isNullRelative == false) {
                        if (this.personRelativeModel.postTitle == null) {
                            this.personRelativeModel.postTitle = " ";
                        }
                        this.personModel.personRelativeViewModel = [];
                        this.personModel.personRelativeViewModel.push(this.personRelativeModel);

                    }
                    this.$store.dispatch("CreatePerson", this.personModel);
                }
            },
            getPersonNo() {
                this.$http.get("Person/GetPersonCode")
                    .then(data => {
                        this.personModel.code = data.data.toString();
                    });
               
            },
            fixTime() {
                var val = this.personModel.workUsedTime;
                if (val.length == 1) {
                    val = '0' + val + ':00';
                }
                else if (val.length == 2) {
                    val = val + ':00';
                }
                else if (val.length == 3) {
                    val = val + '00';
                }
                else if (val.length == 4) {
                    val = val + '0';
                }
                this.personModel.workUsedTime = val;
            },
            onNameChange() {
                this.personModel.title = this.personModel.firstName + " " + this.personModel.lastName;
            },
        },

        validations: {
            personModel: {
                code: {
                    required,
                },
                title: {
                    required
                },
                legalTypeId: {
                    required: requiredIf(function () {
                        return this.personModel.ownerShipTypeId == 2;
                    })
                },
                firstName: {
                    required: requiredIf(function () {
                        return this.personModel.ownerShipTypeId == 1;
                    })
                },
                lastName: {
                    required: requiredIf(function () {
                        return this.personModel.ownerShipTypeId == 1;
                    })
                },
                ownerShipTypeId: {
                    required
                },
                reference: {
                    maxLength: maxLength(200)
                },
                personGroupIds: {
                    required
                },
               
               
            },
            personDetailsModel: {
                title: {
                    requiredIfTitle:requiredIf(function() {
                        return this.isNullDetails.toString()=='false'
                    }),
                },
                stateId: {
                    requiredIfState: requiredIf(function () {
                        return this.isNullDetails.toString()=='false'
                    }),
                },
                emailAddress: {
                    email
                },
                webSiteAddress: {
                    url
                }
            },
            personRelativeModel: {
                fullName: {
                    required: requiredIf(function () {
                        return this.isNullRelative == false
                    }),
                },
                emailAddress: {
                    email
                }
            }


        },
        directives: { maska }

    };
</script>
